import { useTranslation } from "../../../i18n";
import { Badge, Button } from "../../ui";

interface Props {
	onSaveCameraPose: () => void;
	hasSavedPose: boolean;
	onClearSavedPose: () => void;
	cameraReady: boolean;
}

export function UploadPreviewCameraPanel({ onSaveCameraPose, hasSavedPose, onClearSavedPose, cameraReady }: Props) {
	const { t } = useTranslation();

	return (
		<details className="mt-4 rounded-lg border border-border p-4">
			<summary className="cursor-pointer text-sm font-medium">{t("uploadModal.adjustInitialCamera")}</summary>
			<div className="mt-4 flex flex-col gap-4">
				<p className="text-sm text-muted-foreground">{t("uploadModal.adjustInitialCameraDesc")}</p>
				<div className="flex flex-wrap items-center gap-2">
					<Button variant="secondary" size="sm" disabled={!cameraReady} onClick={onSaveCameraPose}>
						{t("uploadModal.setCameraPoseAsDefault")}
					</Button>
					{hasSavedPose && (
						<>
							<Badge variant="secondary">{t("uploadModal.cameraPoseLocked")}</Badge>
							<Button variant="ghost" size="sm" onClick={onClearSavedPose}>
								{t("uploadModal.cameraPoseUnlock")}
							</Button>
						</>
					)}
				</div>
			</div>
		</details>
	);
}
